import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILED,
  REMOVE,
  REMOVE_SUCCESS,
  REMOVE_FAILED,
} from './constants';

export const initAction = (id: string, budgetId: string) => ({
  type: INIT,
  id,
  budgetId,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});

export const initFailedAction = (error: any, errorCode?: string) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export const saveAction = (data: any) => ({
  type: SAVE,
  data,
});
export const saveSuccessAction = (form: any) => ({
  type: SAVE_SUCCESS,
  form,
});
export const saveFailedAction = (error: any, errorCode: string, additional?: any) => ({
  type: SAVE_FAILED,
  error,
  errorCode,
  ...additional,
});

export const removeAction = (donationCreditRuleId: string) => ({
  type: REMOVE,
  donationCreditRuleId,
});
export const removeSuccessAction = () => ({
  type: REMOVE_SUCCESS,
});
export const removeFailedAction = (error: any, errorCode: string, additional?: any) => ({
  type: REMOVE_FAILED,
  error,
  errorCode,
  ...additional,
});
